import { WhatsappLogo, Phone, Clock } from "@phosphor-icons/react";
import { IMG } from "@/lib/products";
import { useLang } from "@/lib/i18n";
import { PageHero } from "@/components/PageBits";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Reveal } from "@/components/Reveal";
import { SITE, openWhatsApp } from "@/lib/site";

export default function Enquiry() {
  const { t } = useLang();
  return (
    <div>
      <PageHero
        eyebrow={t("enquiryPage.eyebrow")}
        title={t("enquiryPage.title")}
        subtitle={t("enquiryPage.subtitle")}
        image={IMG.waterFlow}
      />

      <section className="container-x py-16 md:py-24" data-testid="enquiry-page">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.3fr]">
          <Reveal>
            <p className="overline mb-4">{t("enquiryPage.sideEyebrow")}</p>
            <h2 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-forest">
              {t("enquiryPage.sideTitle")}
            </h2>
            <p className="mt-5 text-ink/70">{t("enquiryPage.sideText")}</p>

            <div className="mt-10 space-y-5">
              <button onClick={() => openWhatsApp()} className="flex w-full items-center gap-4 rounded-xl border border-hairline bg-surface p-5 text-left shadow-sm transition-colors hover:border-forest" data-testid="enquiry-whatsapp-quick">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#25D366] text-white">
                  <WhatsappLogo size={26} weight="fill" />
                </span>
                <span>
                  <span className="block font-semibold text-forest">{t("enquiryPage.chatWhatsapp")}</span>
                  <span className="text-sm text-subtle">{t("enquiryPage.fastest")} · {SITE.phoneDisplay}</span>
                </span>
              </button>
              <a href={`tel:${SITE.phoneRaw}`} className="flex w-full items-center gap-4 rounded-xl border border-hairline bg-surface p-5 text-left shadow-sm transition-colors hover:border-forest">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-forest text-white">
                  <Phone size={24} weight="fill" />
                </span>
                <span>
                  <span className="block font-semibold text-forest">{t("enquiryPage.callUs")}</span>
                  <span className="text-sm text-subtle">{SITE.phoneDisplay}</span>
                </span>
              </a>
              <div className="flex w-full items-center gap-4 rounded-xl border border-hairline bg-surface p-5 text-left shadow-sm">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-gold text-forest">
                  <Clock size={24} weight="fill" />
                </span>
                <span>
                  <span className="block font-semibold text-forest">{t("enquiryPage.workingHours")}</span>
                  <span className="text-sm text-subtle">{t("enquiryPage.hoursValue")}</span>
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <EnquiryForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
